module.exports = __webpack_public_path__ + "img/money.bcd39068.png";